<template>
  <div :class="'documents-block ' + 'documents'">
    <preloader :visible="preloader" />
    <alert-message :message="message" />
    <div class="actions-bts" style="text-align: right; padding-bottom: 5px">
      <a class="mr-2 mb-2 btn btn-sm btn-success" v-on:click="runAction('/service/restore')">Restore</a>
    </div>
    <v-server-table ref="vuetable" :url="route" :columns="columns" :options="options" @loading="onLoading" @loaded="onLoaded" v-if="columns"  class="custom-table-modifier">
      <div slot="device" slot-scope="props_data" v-if="props_data.row.device">{{ props_data.row.device.serial }}</div>
      <div slot="starts_at" slot-scope="props_data">
        <span v-html="momentVue(props_data.row.starts_at).format(dateFormat).replace(/\s/,'<br>')"></span>
      </div>
      <div slot="finishes_at" slot-scope="props_data">
        <span v-html="momentVue(props_data.row.finishes_at).format(dateFormat).replace(/\s/,'<br>')"></span>
      </div>
      <div slot="last_updated" slot-scope="d">
        <span v-if="d.row.last_updated" :style="{ color: getColor(momentDiff(d.row.last_updated)) }"><b>{{ momentFromNow(d.row.last_updated) }}</b></span>
        <span v-else style="color:#fb434a"><b>Never</b></span>
      </div>
      <div slot="filter__select">
        <input type="checkbox" class="form-control" v-model="allMarked" v-on:change="markAll()">
      </div>
      <div slot="select" slot-scope="props_data">
        <input type="checkbox" class="form-control" v-model="checkboxes[props_data.row.id]" v-on:change="toggleCheckbox(props_data.row.id)">
      </div>
    </v-server-table>
  </div>
</template>

<script>
import Preloader from "./blocks/preloader";
import AlertMessage from "./blocks/alert-message";

export default {
  components: { AlertMessage, Preloader },
  props: {
    route: {
      type: String
    },
    dateFormat: {
      type: String,
      default: 'MM-DD-YYYY'
    },
    appUrl: {
      type: String,
    },
    settings: {
      type: String,
    },
  },
  data() {
    return {
      allMarked: false,
      checkboxes: {},
      message: '',
      preloader: false,
      columns: [ 'select', 'id', 'device', 'name', 'starts_at', 'finishes_at', 'last_updated' ],
      options: {
        filterByColumn: true,
        debounce: 1000,
        requestFunction: (data) => {
          return axios.get(this.route, { params: data });
        },
        dateColumns:[ 'starts_at', 'finishes_at', 'last_updated' ],
        dateFormat: this.dateFormat,
        datepickerOptions: {
          showDropdowns: true,
          autoUpdateInput: true,
        },
        orderBy: {
          ascending: false,
        },
        sortable: [ 'id', 'name', 'starts_at', 'finishes_at' ],
        filterable: [ 'id', 'device', 'name', 'starts_at', 'finishes_at', 'last_updated' ],
        perPage: 30,
        pagination: {
          chunk:30,
          dropdown:false
        },
        headings: {
          id: 'ID',
          device: 'Device',
          name: 'Name',
          starts_at: 'Start',
          finishes_at: 'Finish',
          last_updated: 'Updated',
        }
      }
    }
  },
  methods: {
    momentVue(...args) {
      return moment.utc(...args);
    },
    momentDiff(timestamp) {
      return moment().diff(moment.utc(timestamp), 'minutes');
    },
    momentFromNow(timestamp) {
      return moment.utc(timestamp).fromNow();
    },
    getColor(minutes) {
      const settings = JSON.parse(this.settings);
      let color = null;
      for (const i in settings) {
        if (settings[i].from <= minutes) {
          color = settings[i].color;
        }
      }
      return color;
    },
    toggleCheckbox(id) {
      let count = 0;
      let total = 0;
      for (const item in this.checkboxes) {
        ++total;
        if (this.checkboxes[item]) {
          ++count;
        }
      }
      if (this.allMarked) {
        if (total !== count) {
          this.allMarked = false;
        }
      } else {
        if (total === count) {
          this.allMarked = true;
        }
      }
    },
    markAll() {
      for (const item in this.checkboxes) {
        this.checkboxes[item] = this.allMarked;
      }
    },
    onLoading(e) {
      this.preloader = true;
    },
    onLoaded(e) {
      const temp = e.data.data;
      for (let i = 0; i < e.data.data.length; ++i) {
        this.$set(this.checkboxes, temp[i].id, false)
      }

      this.preloader = false;
    },
    deleteItems() {
      this.runAction('/setting/delete_old/all');
    },
    runAction(url) {
      const services = Object.keys(this.checkboxes).filter(key => this.checkboxes[key]);
      if (!Array.isArray(services) || services.length < 1) {
        this.message = 'Select items first.';
        return;
      }

      axios.post(url, { services }).then(response => {
        console.log('response', response);

        if (response.data.error) {
          this.message = response.data.error;
        } else {
          this.message = response.data.success;
          this.$refs.vuetable.getData()
        }
      }).catch(e => {
        console.log(e);
        this.message = e;
      });
    }
  }
}
</script>